define(function(require) {
	const activation_model = require('civicsModels/core/activation_model');

	return {
		handleActivation: function(successCallback, errorCallback, provider = null, activationToken = null, providerUserId = null) {
			const activationCode = App.sessionStorage.get('CIVICS', 'ACTIVATION_CODE');
			
			if (activationCode) {
				const activationModel = new activation_model();
				activationModel.id = 1;
				activationModel.set({
					id: 1,
					activationCode: activationCode
				});

				if(provider && activationToken && providerUserId) {
					activationModel.set({
						'socialIdentity' : {
							provider: provider,
							providerUserId: providerUserId,
							activationToken: activationToken
						}
					});
				}
				
				activationModel.save({id: 1}, {
					success: function(message, response, options) {
						App.sessionStorage.remove('CIVICS', 'ACTIVATION_CODE');
						successCallback();
					},
					error: function(message, response, options) {
						App.sessionStorage.remove('CIVICS', 'ACTIVATION_CODE');
						const errorMessage = response.status === 409 
							? i18n.t('CIVICS.SSO.ERROR.INVALID_ACTIVATION_CODE')
							: i18n.t('CIVICS.SSO.ERROR.ACTIVATING');
						errorCallback(errorMessage);
					}
				});
			} else {
				errorCallback(i18n.t('CIVICS.SSO.ERROR.ACTIVATING'));
			}
		}
	};
});
